<template>
    <div class="js-author-detail">
        <div class="content-header">
            <ol class="breadcrumb">
                <li class="active">微信配置</li>
            </ol>
        </div>
        <div class="content-from">
            <el-form ref="formName" :model="saveModel" :rules="rules" label-width="100px">
                <el-form-item label="appId" prop="appId">
                    <el-input v-model="saveModel.appId"></el-input>
                </el-form-item>
                <el-form-item label="appSecret" prop="appSecret">
                    <el-input v-model="saveModel.appSecret"></el-input>
                </el-form-item>
                <el-form-item label="mchId" prop="mchId">
                    <el-input v-model="saveModel.mchId"></el-input>
                </el-form-item>
                <el-form-item label="payKey" prop="payKey">
                    <el-input v-model="saveModel.payKey"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" size="small" @click="saveWeixinConfig">保存</el-button>
                    <el-button size="small" @click="resetForm('formName')">重置</el-button>
                    <el-button size="small" @click="$router.back(-1)">取消</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            saveModel: {
                appId: '',
                appSecret: '',
                mchId: '',
                payKey: ''
            },

            rules: {
                appId: [
                    { required: true, message: "请输入appId", trigger: "blur" }
                ],
                appSecret: [
                    { required: true, message: "请输入appSecret", trigger: "blur" }
                ]
            },
        }
    },
    created() {
        this.findWeixinConfig();
    },
    methods: {
        findWeixinConfig() {
            var _this = this;
            _this.$common.my_ajax({
                url: 'weixinConfig/detailWeixinConfig',
                success(response) {
                    _this.saveModel = response.item || {};
                }
            });
        },
        saveWeixinConfig() {
            var _this = this;
            _this.$refs['formName'].validate((valid) => {
                if (valid) {
                    _this.$common.my_ajax({
                        url: '/weixinConfig/saveWeixinConfig',
                        data: _this.saveModel,
                        success: function(response) {
                            _this.$message({
                                message: '保存成功',
                                type: 'success',
                                duration: 1000
                            });
                        }
                    });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        }
    }
}
</script>